import React from 'react';
import gettext from 'js-utils/gettext';
import map from 'lodash/map';
import isEmpty from 'lodash/isEmpty';
import Badge from 'eventbrite_design_system/badge/Badge';
import SelectField from 'eventbrite_design_system/inputField/SelectField';
import { STYLE_BASIC } from 'eventbrite_design_system/inputField/constants';

import './index.scss';

/*
 * Currently custom css is not working on legacy manage pages.
 * The issue is filed with https://jira.evbhome.com/browse/EB-125954
 * Remove this patch once the above ticket is fixed.
 * using $ui-400
 */
const SeriesEventsElbowStyle = () => {
    const styles = {
        __html: `
            .series-event-elbow-icon {
                display: inline-block;
                margin: 0 12px 3px 8px;
                width: 7px;
                height: 7px;
                border-left: 2px solid #C2C2CC; /* Maps to EDS $ui-400 */
                border-bottom: 2px solid #C2C2CC; /* Maps to EDS $ui-400 */
            }
        `,
    };

    return (
        <style
            type="text/css"
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={styles}
        />
    );
};

/*
 * Currently custom css is not working on legacy manage pages.
 * The issue is filed with https://jira.evbhome.com/browse/EB-125954
 * Remove this patch once the above ticket is fixed.
 * Using $ui-800.
 */
const NavTitleStyle = () => {
    const styles = {
        __html: `
            .event-nav-description-title {
                color: #39364F; /* Maps to EDS $ui-800 */
            }
        `,
    };

    return (
        <style
            type="text/css"
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={styles}
        />
    );
};

const SwitchEventButton = () => (
    <div className="eds-l-pad-top-3">
        <a href="/myevents">{gettext('Switch Event')}</a>
    </div>
);

const EventVenue = ({ venueName }) => {
    if (venueName) {
        return (
            <div className="eds-l-pad-top-2">
                <p className="eds-text-bm">{venueName}</p>
            </div>
        );
    }

    return null;
};

const _handleSeriesDateChange = (eventId) => {
    window.location.assign(`/myevent?eid=${eventId}`);
};

const SeriesDatesDropdown = ({ seriesDates }) => {
    if (isEmpty(seriesDates)) {
        return null;
    }

    const displayValues = map(seriesDates, ({ eventId, dateTimeShort }) => ({
        value: eventId,
        display: dateTimeShort,
    }));

    return (
        <div className="eds-l-mar-top-5">
            <SelectField
                style={STYLE_BASIC}
                values={displayValues}
                disabled={false}
                label={gettext('Select dates')}
                placeholder={gettext('Occurrences')}
                onChange={_handleSeriesDateChange}
                data-spec="series-dates-dropdown"
            />
        </div>
    );
};

const EventSeriesParentDescription = ({
    eventName,
    venueName,
    seriesDates,
    eventId,
}) => (
    <div data-spec="series-parent-event-side-nav-desc">
        <NavTitleStyle />
        <Badge bgColor="ui-600" text={gettext('Master')} />

        <h3 className="eds-text-hs--fixed eds-text-weight--light">
            <a
                className="event-nav-description-title"
                href={`/myevent?eid=${eventId}`}
            >
                {eventName}
            </a>
        </h3>

        <SeriesDatesDropdown seriesDates={seriesDates} />

        <EventVenue venueName={venueName} />
    </div>
);

const EventSeriesChildDescription = ({
    eventName,
    eventDate,
    venueName,
    seriesDates,
    parentId,
}) => (
    <div data-spec="series-child-event-side-nav-desc">
        <SeriesEventsElbowStyle />

        <h3 className="eds-text-hs--fixed eds-text-weight--light">
            <a href={`/myevent?eid=${parentId}`}>{eventName}</a>
        </h3>

        <p className="eds-l-pad-top-1">
            <span className="series-event-elbow-icon" />
            {eventDate}
        </p>

        <SeriesDatesDropdown seriesDates={seriesDates} />

        <EventVenue venueName={venueName} />
    </div>
);

const EventDescription = ({ eventName, eventId, eventDate, venueName }) => (
    <div
        data-automation="coyote-sidebar-description"
        data-spec="event-side-nav-desc"
    >
        <NavTitleStyle />
        <h3 className="eds-text-hs--fixed eds-text-weight--light">
            <a
                className="event-nav-description-title"
                href={`/myevent?eid=${eventId}`}
            >
                {eventName}
            </a>
        </h3>
        <p className="eds-l-pad-top-2">{eventDate}</p>

        <EventVenue venueName={venueName} />

        <SwitchEventButton />
    </div>
);

const SideDrawerDescription = ({
    eventName,
    eventDate,
    venueName,
    isSeriesParent,
    isSeriesChild,
    seriesDates = [],
    parentId,
    eventId,
}) => {
    if (isSeriesParent) {
        return (
            <EventSeriesParentDescription
                eventName={eventName}
                venueName={venueName}
                seriesDates={seriesDates}
                eventId={eventId}
            />
        );
    } else if (isSeriesChild) {
        return (
            <EventSeriesChildDescription
                eventName={eventName}
                eventDate={eventDate}
                venueName={venueName}
                seriesDates={seriesDates}
                parentId={parentId}
            />
        );
    }

    return (
        <EventDescription
            eventName={eventName}
            eventDate={eventDate}
            venueName={venueName}
            eventId={eventId}
        />
    );
};

export default SideDrawerDescription;
